import React, { useState, useEffect } from 'react';
import { H5 } from '@blueprintjs/core'
import {
    ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, Cell, ResponsiveContainer, ZAxis
} from 'recharts';
import { scaleOrdinal } from 'd3-scale';
import { schemeCategory10 } from 'd3-scale-chromatic';
import DefaultTooltipContent from 'recharts/lib/component/DefaultTooltipContent';

const CustomTooltip = props => {

    if (props.payload[0] != null) {

        const newPayload = [
            {
                name: 'Image',
                value: props.payload[0].payload.name,
            },
            ...props.payload,
        ];
        return <DefaultTooltipContent {...props} payload={newPayload} />;
    }
    return <DefaultTooltipContent {...props} />;
};

const colors = scaleOrdinal(schemeCategory10).range();

const SimpleScatter = ({ YAxisName, XAxisName, XUnit, YUnit, data }) => {

    const [maxY, setMaxY] = useState(0)
    const [maxX, setMaxX] = useState(0)

    useEffect(() => {
        let max = 0
        let maxXScore = 0
        if (data && data.length > 0) {
            data.forEach((dat, i) => {
                if (dat.y) {
                    if (parseFloat(dat.y) > max) {
                        max = parseFloat(dat.y)
                    }
                }
                if (dat.x) {
                    if (parseFloat(dat.x) > maxXScore) {
                        maxXScore = parseFloat(dat.x)
                    }
                }

            })
        }
        setMaxY(max)
        setMaxX(maxXScore)

    }, [data])

    return (
        <div className='basic-chart attribute-scatter-container'>
            <H5 className='title-results' style={{ width: '8%', height: '100%', diplay: 'flex', alignItems: 'center' }}>
                {YAxisName}
            </H5>
            <div style={{ width: '92%', height: 500 }} >
                <ResponsiveContainer>
                    <ScatterChart
                        width={400}
                        height={400}
                        margin={{
                            top: 20, right: 40, bottom: 20, left: 40,
                        }}
                    >
                        <CartesianGrid />
                        <XAxis type="number" dataKey="x" name={XAxisName} unit={XUnit} domain={[0, maxX]} tick={{ fill: 'rgba(255, 255, 255, 0.938)' }} />
                        <YAxis type="number" dataKey="y" name={YAxisName} unit={YUnit} domain={[0, maxY]} tick={{ fill: 'rgba(255, 255, 255, 0.938)' }} />
                        <ZAxis scale="log" range={[500, 500]} />
                        <Tooltip content={<CustomTooltip />} />
                        <Scatter name="A school" data={data} fill="#8884d8" >
                            {
                                data.map((entry, index) => <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />)
                            }
                        </Scatter>
                    </ScatterChart>
                </ResponsiveContainer>
                <H5 className='title-results text-center' style={{ width: '100%' }}>
                    {XAxisName}
                </H5>
                <div className="scatter-legends">
                    {data.map((entry, i) => {
                        return (
                            <div className="scatter-legend" key={i}>
                                <div style={{ backgroundColor: colors[i % colors.length] }} className="scatter-circle"></div>
                                <div>&nbsp;	{entry.name}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    );
}


export default SimpleScatter